import styled, { css } from 'styled-components';

export const PromoSlider = styled.div`
	${({ theme }) => css`
		border: solid 1px ${theme.colors.neutral[200]};
		border-radius: ${theme.radii.m};
		padding: 1.5rem 1rem;

		@media ${theme.screens.screenGTS} {
			padding: 2rem 2rem;
		}
	`}
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
`;

export const PromoTitle = styled.span`
	${({ theme }) => css`
		font-weight: ${theme.fontWeights.bold};
		font-size: ${theme.fontSizes.default};
	`}
`;

export const PromoContent = styled.span`
	align-self: start;
	
	${({ theme }) => css`
		font-size: ${theme.fontSizes.default};
		color: ${theme.colors.neutral[400]};
	`}

	& ul {
		list-style: none;
		padding: 0;
	}
	
	& li {
		display: -webkit-inline-box;
	}

	& li:not(:last-child) {
		margin-bottom: 0.75rem;
	}
`;
